import { render, staticRenderFns } from "./repair_former.vue?vue&type=template&id=069f8c1e&"
import script from "./repair_former.vue?vue&type=script&lang=js&"
export * from "./repair_former.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports